import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-wrap" }
const _hoisted_2 = { class: "card-body p-0" }
const _hoisted_3 = { class: "card-p mb-10" }
const _hoisted_4 = { class: "fs-2 p-2 border-gray-300 border-bottom-dashed" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "text-center px-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "mw-100 mh-300px card-rounded-bottom",
    alt: "",
    src: "examples.png"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lessonsStudentCountListWithFallback, (lessonCount, i) => {
      return (_openBlock(), _createElementBlock("div", {
        key: lessonCount.durationId
      }, [
        (lessonCount?.lessonCount > 0)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["card shadow-sm m-4", [_ctx.BG_COLOR[i].bgColor, _ctx.BG_COLOR[i].textColor]]),
              style: {"width":"260px","height":"150px"}
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("p", _hoisted_4, " Student for " + _toDisplayString(15 * (i + 1)) + " min ", 1),
                  _createElementVNode("h2", {
                    class: _normalizeClass(_ctx.BG_COLOR[i].textColor)
                  }, _toDisplayString(lessonCount?.lessonCount), 3),
                  _hoisted_5
                ])
              ])
            ], 2))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}